import http from "./configServices/httpService";
import { getCookies } from "../utils";
import { base_url } from "./configServices/config";

// Start Auth
export const signInService = (data) => {
  // Moved to the domain-specific admin namespace
  return http.post(`${base_url}/api/admin/v2/login/`, data);
};
// End Auth

// Start OTP
export const sendOTPService = (data) => {
  return http.post(`${base_url}/auth/mobile/`, data);
};

export const verifyOTPService = (data) => {
  return http.post(`${base_url}/callback/auth/`, data);
};
// End OTP

// Start Config
export const getConfigsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/config/`, { params });
};
export const editConfigService = (data) => {
  return http.put(`${base_url}/api/admin/v2/config/${data.key}/`, data);
};
// End Config

// Start Profile
// Even though this is the Admin React project, admins are still Users 
// and hit the client API for their personal profile updates
export const editInfoService = (data, token) => {
  return http.post(
    `${base_url}/api/client/v2/profile/update/`,
    data,
    token
      ? {
          headers: {
            Authorization: `token ${token}`,
          },
        }
      : {}
  );
};

export const sendUserProfilePhotoService = (data) => {
  return http.post(`${base_url}/api/client/v2/image/upload/`, data);
};

export const getUserProfilePhotoService = (data) => {
  return http.post(`${base_url}/api/client/v2/image/download/`, data);
};

export const getUserProfileService = () => {
  return http.get(`${base_url}/api/client/v2/profile/read/`);
};
// End Profile

// Start Survey
export const getSurveyItemsService = () => {
  // Lists moved to Core
  return http.post(`${base_url}/api/core/v2/survey_item/list/`);
};

export const createSurveyItemService = (data) => {
  // Writes moved to Admin
  return http.post(`${base_url}/api/admin/v2/survey_item/create/`, data);
};

export const deleteSurveyItemService = (data) => {
  return http.delete(`${base_url}/api/admin/v2/survey_item/delete/`, {
    data,
  });
};

export const sendSurveyService = (data) => {
  return http.post(`${base_url}/api/admin/v2/orders/update_survey/`, data);
};
// End Survey

// Start Category

export const getCategoryItemsService = (params) => {
  // Changed from POST to standard GET list
  return http.get(`${base_url}/api/admin/v2/service_categories/`, { params });
};

export const getCategoryService = (id) => {
  // Changed from POST to GET, passing ID in the URL
  return http.get(`${base_url}/api/admin/v2/service_categories/${id}/`);
};

export const createCategoryItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/service_categories/`, data);
};

export const editCategoryItemService = (data) => {
  // Changed from POST to PATCH/PUT, passing ID in the URL
  return http.put(`${base_url}/api/admin/v2/service_categories/${data.id}/`, data);
};

export const deleteCategoryItemService = (id) => {
  // Changed to standard REST deletion by ID in the URL
  return http.delete(`${base_url}/api/admin/v2/service_categories/${id}/`);
};
// End Category

// Start Canceling Reason (Moved to Admin ViewSet)
export const getCancelingReasonService = () => {
  return http.get(`${base_url}/api/admin/v2/canceling_reason/`);
};

export const createCancelingReasonService = (data) => {
  return http.post(`${base_url}/api/admin/v2/canceling_reason/`, data);
};

export const deleteCancelingReasonService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/canceling_reason/${id}/`);
};
// End Canceling Reason

// Start Failing Reason (Moved to Admin ViewSet)
export const getFailingReasonService = (params) => {
  return http.get(`${base_url}/api/admin/v2/failing_reason/`, { params });
};

export const createFailingReasonService = (data) => {
  return http.post(`${base_url}/api/admin/v2/failing_reason/`, data);
};

export const deleteFailingReasonService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/failing_reason/${id}/`);
};
// End Failing Reason

// Start Return User Status
export const getReturnUserStatusService = () => {
  return http.get(`${base_url}/api/admin/v2/return_user_status/`);
};

export const createReturnUserStatusService = (data) => {
  return http.post(`${base_url}/api/admin/v2/return_user_status/`, data);
};

export const deleteReturnUserStatusService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/return_user_status/${id}/`);
};
// End Return User Status

// Start Employer
export const createUserEmployerService = (data) => {
  return http.post(`${base_url}/api/admin/v2/user_employer/create/`, data);
};

export const deleteUserEmployerService = (data) => {
  return http.post(`${base_url}/api/admin/v2/user_employer/delete/`, data);
};

export const getEmployersService = (params) => {
  return http.get(`${base_url}/api/admin/v2/employers/`, { params });
};

export const createEmployerService = (data) => {
  return http.post(`${base_url}/api/admin/v2/employers/`, data);
};

export const editEmployerService = (data) => {
  return http.put(`${base_url}/api/admin/v2/employers/${data.id}/`, data);
};

export const deleteEmployerService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/employers/${id}/`);
};
// End Employer

// Start Group Charge
export const createGroupChargeService = (data) => {
  return http.post(`${base_url}/api/admin/v2/group_charge/`, data);
};
// End Group Charge

// Start Personnel
export const getPersonnelsEmployerService = (params) => {
  return http.get(`${base_url}/api/admin/v2/employees/`, { params });
};

export const getPersonnelsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/personnels/`, { params });
};

export const getPersonnelService = (data) => {
  return http.get(`${base_url}/api/admin/v2/personnels/${data.id}/`);
};

export const createPersonnelService = (data) => {
  return http.post(`${base_url}/api/admin/v2/personnels/`, data);
};

export const editPersonnelsService = (data) => {
  return http.put(`${base_url}/api/admin/v2/personnels/${data.id}/`, data);
};

export const deletePersonnelService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/personnels/${id}/`);
};

export const getEnteredEmployeeCodeService = (params) => {
  return http.get(`${base_url}/api/admin/v2/entered_employee_code/`, { params });
};
// End Personnel

// Start Service
export const getServicesService = (data) => {
  return http.post(`${base_url}/api/admin/v2/services/all/`, data);
};

export const createServiceService = (data) => {
  return http.post(`${base_url}/api/admin/v2/moderator/create_update/`, data);
};

export const editServiceService = (data) => {
  return http.post(`${base_url}/api/admin/v2/moderator/create_update/`, data);
};

export const getServiceService = (data) => {
  // Moved to Core shared namespace
  return http.post(`${base_url}/api/core/v2/moderator/read/`, data);
};

export const deleteServiceService = (data) => {
  return http.delete(`${base_url}/api/admin/v2/moderator/delete/`, { data });
};
// End Service

// Start User
export const getUsersService = (params) => {
  return http.get(`${base_url}/api/admin/v2/users/`, { params });
};

export const getUserService = (id) => {
  return http.get(`${base_url}/api/admin/v2/users/${id}/`);
};

export const createUserService = (data) => {
  return http.post(`${base_url}/api/admin/v2/users/`, data);
};

export const editUserService = (data) => {
  return http.put(`${base_url}/api/admin/v2/users/${data.pk}/`, data);
};

export const deleteUserService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/users/${id}/`);
};

export const getUserAddressesService = (data) => {
  return http.post(`${base_url}/api/admin/v2/address/list/`, data);
};

export const createUserAddressService = (data) => {
  return http.post(`${base_url}/api/admin/v2/address/create_update/`, data);
};

export const editUserAddressService = (data) => {
  return http.post(`${base_url}/api/admin/v2/address/create_update/`, data);
};
// End User

// Start Order
export const getOrdersService = (data) => {
  return http.post(`${base_url}/api/admin/v2/orders/list/`, data, {
    params: data,
  });
};

export const getOrderService = (data) => {
  return http.post(`${base_url}/api/admin/v2/orders/read/`, data);
};

export const createOrderService = (data) => {
  return http.post(`${base_url}/api/admin/v2/orders/create_update/`, data);
};

export const editOrderService = (data) => {
  return http.post(`${base_url}/api/admin/v2/orders/create_update/`, data);
};

export const deleteOrderService = (data) => {
  return http.delete(`${base_url}/api/admin/v2/orders/delete/`, { data });
};

export const sendSMSToPersonnelService = (data) => {
  return http.post(`${base_url}/api/admin/v2/personnel/send_sms/`, data);
};

export const sendEducationalSMSService = (data) => {
  return http.post(`${base_url}/api/admin/v2/personnel/send_educational_sms/`, data);
};

export const sendOrderToPersonnelSMSService = (data) => {
  return http.post(`${base_url}/api/admin/v2/personnel/send_order/`, data);
};

export const editAddressService = (data) => {
  return http.post(`${base_url}/api/admin/v2/address/create_update/`, data);
};
// End Order

// Start Log
export const runShellStatisticsService = (data) => {
  return http.post(`${base_url}/api/admin/v2/statistics/run_shell/`, data);
};

export const getLogsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/admin_logs/`, { params });
};

export const createLogService = (data) => {
  return http.post(`${base_url}/api/admin/v2/admin_logs/`, data);
};
// End Log

// Start Province
export const getProvincesService = (params) => {
  return http.get(`${base_url}/api/admin/v2/provinces/`, { params });
};

export const createProvinceService = (data) => {
  return http.post(`${base_url}/api/admin/v2/provinces/`, data);
};

export const editProvinceService = (data) => {
  return http.put(`${base_url}/api/admin/v2/provinces/${data.id}/`, data);
};

export const deleteProvinceService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/provinces/${id}/`);
};
// End Province

// Start City
export const getCitiesService = (params) => {
  return http.get(`${base_url}/api/admin/v2/cities/`, { params });
};

export const createCityService = (data) => {
  return http.post(`${base_url}/api/admin/v2/cities/`, data);
};

export const editCityService = (data) => {
  return http.put(`${base_url}/api/admin/v2/cities/${data.id}/`, data);
};

export const deleteCityService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/cities/${id}/`);
};
// End City

// Start Use Discount
export const getUseDiscountsService = (data) => {
  return http.post(`${base_url}/api/admin/v2/discountcoupon/used/`, data);
};
// End Discount

// Start Invoice
export const getInvoicesService = (params) => {
  return http.get(`${base_url}/api/admin/v2/invoices/`, { params });
};
export const getInvoiceService = (invoiceId) => {
  return http.get(`${base_url}/api/admin/v2/invoices/${invoiceId}/`);
};
export const createInvoiceService = (data) => {
  return http.post(`${base_url}/api/admin/v2/invoices/`, data);
};
export const deleteInvoiceService = (invoiceId) => {
  return http.delete(`${base_url}/api/admin/v2/invoices/${invoiceId}/`);
};
export const editInvoiceService = (data) => {
  return http.put(`${base_url}/api/admin/v2/invoices/${data.id}/`, data);
};
export const sendInvoiceToClientService = (id) => {
  return http.get(`${base_url}/api/admin/v2/invoice/send_to_client/${id}/`);
};
// End Invoice

// Start Discount Coupon
export const getDiscountCouponItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/discount-coupons/`, { params });
};

export const getDiscountCouponService = (id) => {
  return http.get(`${base_url}/api/admin/v2/discount-coupons/${id}/`);
};

export const createDiscountCouponItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/discount-coupons/`, data);
};

export const editDiscountCouponItemService = (data) => {
  return http.put(`${base_url}/api/admin/v2/discount-coupons/${data.id}/`, data);
};

export const deleteDiscountCouponItemService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/discount-coupons/${id}/`);
};

export const editDiscountService = (data) => {
  return http.put(`${base_url}/api/admin/v2/discount/create_update/`, data);
};

export const checkDiscountService = (data) => {
  return http.post(`${base_url}/api/admin/v2/discount/check/`, JSON.stringify(data));
};
// End Discount Coupon

// Start Analysis
export const kpiAnalysisService = (data) => {
  return http.post(`${base_url}/api/admin/v2/kpi_analysis/`, data);
};
// End Analysis

// Start Wallet
export const getWalletsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/wallet/`, { params });
};

export const getWalletService = (userId) => {
  return http.get(`${base_url}/api/admin/v2/wallet/${userId}/`);
};

export const editWalletService = (data) => {
  return http.put(`${base_url}/api/admin/v2/wallet/${data.user}/`, data);
};

export const deleteWalletService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/wallet/${id}/`);
};
// End Wallet

// Start Payment Transaction
export const getPaymentTransactionsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/paymenttransactions/`, { params });
};

export const getPaymentTransactionService = (id) => {
  return http.get(`${base_url}/api/admin/v2/paymenttransactions/${id}/`);
};

export const editPaymentTransactionService = (id, data) => {
  return http.put(`${base_url}/api/admin/v2/paymenttransactions/${id}/`, data);
};

export const deletePaymentTransactionService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/paymenttransactions/${id}/`);
};
// End Payment Transaction

// Start Transaction
export const getTransactionsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/wallet/transactions/`, { params });
};

export const getUserTransactionsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/wallet/${params.user_id}/transactions/`, { params });
};
// End Transaction

// Start Employee
export const getEmployeesService = (params) => {
  return http.get(`${base_url}/api/admin/v2/employees/`, { params });
};

export const createEmployeeService = (data) => {
  return http.post(`${base_url}/api/admin/v2/employees/`, data);
};
export const editEmployeeService = (id, data) => {
  return http.put(`${base_url}/api/admin/v2/employees/${id}/`, data);
};
export const deleteEmployeeService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/employees/${id}/`);
};
// End Employee

// Start User Satisfaction Item
export const getUserSatisfactionItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/usersatisfactionitems/`, { params });
};

export const createUserSatisfactionItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/usersatisfactionitems/`, data);
};
export const editUserSatisfactionItemService = (id, data) => {
  return http.put(`${base_url}/api/admin/v2/usersatisfactionitems/${id}/`, data);
};
export const deleteUserSatisfactionItemService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/usersatisfactionitems/${id}/`);
};
// End User Satisfaction Item

// Start Rejection Reason Item
export const getRejectionReasonItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/rejection-reasons/`, { params });
};

export const createRejectionReasonItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/rejection-reasons/`, data);
};
export const editRejectionReasonItemService = (id, data) => {
  return http.put(`${base_url}/api/admin/v2/rejection-reasons/${id}/`, data);
};
export const deleteRejectionReasonItemService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/rejection-reasons/${id}/`);
};
// End Rejection Reason Item

// Start Recruitment Item
export const getRecruitmentItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/recruitments/`, { params });
};

export const createRecruitmentItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/recruitments/`, data);
};
export const editRecruitmentItemService = (id, data) => {
  return http.put(`${base_url}/api/admin/v2/recruitments/${id}/`, data);
};
export const deleteRecruitmentItemService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/recruitments/${id}/`);
};
// End Recruitment Item

// Start Failure Request Comment Item
export const getFailureRequestCommentItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/failurerequestcomments/`, { params });
};

export const createFailureRequestCommentItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/failurerequestcomments/`, data);
};
export const editFailureRequestCommentItemService = (data) => {
  return http.put(`${base_url}/api/admin/v2/failurerequestcomments/${data.id}/`, data);
};
export const deleteFailureRequestCommentItemService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/failurerequestcomments/${id}/`);
};
// End Failure Request Comment Item

// Start Failure Request Item
export const getFailureRequestItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/failurerequestitems/`, { params });
};

export const createFailureRequestItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/failurerequestitems/`, data);
};
export const editFailureRequestItemService = (data) => {
  return http.put(`${base_url}/api/admin/v2/failurerequestitems/${data.id}/`, data);
};
export const deleteFailureRequestItemService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/failurerequestitems/${id}/`);
};
// End Failure Request Item

// Start Failure Request
export const getFailureRequestsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/failurerequests/`, { params });
};
export const getFailureRequestService = (id) => {
  return http.get(`${base_url}/api/admin/v2/failurerequests/${id}/`);
};
export const createFailureRequestService = (data) => {
  return http.post(`${base_url}/api/admin/v2/failurerequests/`, data);
};
export const editFailureRequestService = (data) => {
  return http.put(`${base_url}/api/admin/v2/failurerequests/${data.id}/`, data);
};
export const deleteFailureRequestService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/failurerequests/${id}/`);
};
// End Failure Request

// Start Violation Solved Item
export const getViolationSolvedItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/violationsolveditems/`, { params });
};

export const createViolationSolvedItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/violationsolveditems/`, data);
};
export const editViolationSolvedItemService = (data) => {
  return http.put(`${base_url}/api/admin/v2/violationsolveditems/${data.id}/`, data);
};
export const deleteViolationSolvedItemService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/violationsolveditems/${id}/`);
};
// End Violation Solved Item

// Start Violation Type Item
export const getViolationTypeItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/violationtypeitems/`, { params });
};

export const createViolationTypeItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/violationtypeitems/`, data);
};
export const editViolationTypeItemService = (data) => {
  return http.put(`${base_url}/api/admin/v2/violationtypeitems/${data.id}/`, data);
};
export const deleteViolationTypeItemService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/violationtypeitems/${id}/`);
};
// End Violation Type Item

// Start Violation Comment
export const getViolationCommentItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/violationcomments/`, { params });
};

export const createViolationCommentItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/violationcomments/`, data);
};
export const editViolationCommentItemService = (data) => {
  return http.put(`${base_url}/api/admin/v2/violationcomments/${data.id}/`, data);
};
export const deleteViolationCommentItemService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/violationcomments/${id}/`);
};
// End Violation Comment

// Start Violation Result Item
export const getViolationResultItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/violationresultitems/`, { params });
};

export const createViolationResultItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/violationresultitems/`, data);
};
export const editViolationResultItemService = (data) => {
  return http.put(`${base_url}/api/admin/v2/violationresultitems/${data.id}/`, data);
};
export const deleteViolationResultItemService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/violationresultitems/${id}/`);
};
// End Violation Result Item

// Start Violations
export const getViolationsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/violations/`, { params });
};
export const getViolationService = (id) => {
  return http.get(`${base_url}/api/admin/v2/violations/${id}/`);
};
export const createViolationService = (data) => {
  return http.post(`${base_url}/api/admin/v2/violations/`, data);
};
export const editViolationService = (data) => {
  return http.put(`${base_url}/api/admin/v2/violations/${data.id}/`, data);
};
export const deleteViolationService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/violations/${id}/`);
}
// End Violations

// Start Comment
export const addOrderCommentService = (data) => {
  return http.post(`${base_url}/api/admin/v2/orders/add_comment/`, data);
};
export const addPersonnelCommentService = (data) => {
  return http.post(`${base_url}/api/admin/v2/personnel/add_comment/`, data);
};
// End Comment

// Start Critics Suggestions
export const getCriticsSuggestionsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/admincriticssuggestions/`, { params });
};
export const editCriticsSuggestionService = (data) => {
  return http.put(`${base_url}/api/admin/v2/admincriticssuggestions/${data.id}/`, data);
};
// End Critics Suggestions

// Start Upload Document
export const uploadPersonnelDocumentService = (data) => {
  return http.post(`${base_url}/api/admin/v2/personnel/document/upload/`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const deletePersonnelDocumentService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/personnel/document/${id}/delete/`);
};
export const getPersonnelDocumentService = (id) => {
  return http.get(`${base_url}/api/admin/v2/personnel/document/${id}/download/`, {
    responseType: "blob",
  });
};
// End Upload Document

// Start SMS Template Item
export const getSMSDispatchLogsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/sms_dispatch_logs/`, { params });
};

export const getSMSTemplateItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/sms_messages/`, { params });
};

export const createSMSTemplateItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/sms_messages/`, data);
};
export const editSMSTemplateItemService = (data) => {
  return http.put(`${base_url}/api/admin/v2/sms_messages/${data.id}/`, data);
};
export const deleteSMSTemplateItemService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/sms_messages/${id}/`);
};
// End SMS Template Item

// Start Roulette Item
export const getRouletteItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/roulette/items/`, { params });
};

export const createRouletteItemService = (data) => {
  return http.post(`${base_url}/api/admin/v2/roulette/items/`, data);
};
export const editRouletteItemService = (id, data) => {
  return http.put(`${base_url}/api/admin/v2/roulette/items/${id}/`, data);
};
export const deleteRouletteItemService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/roulette/items/${id}/`);
};
export const getRouletteResultItemsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/roulette/results/`, { params });
};
// End Roulette Item

// Start Admin
export const getAdminsService = (params) => {
  return http.get(`${base_url}/api/admin/v2/admins/`, { params });
};
export const createAdminService = (data) => {
  return http.post(`${base_url}/api/admin/v2/admins/`, data);
};

export const editAdminService = (data) => {
  return http.put(`${base_url}/api/admin/v2/admins/${data.pk}/`, data);
};

export const deleteAdminService = (id) => {
  return http.delete(`${base_url}/api/admin/v2/admins/${id}/`);
};

export const revokeTokenAdminService = (id) => {
  return http.post(`${base_url}/api/admin/v2/admins/${id}/revoke-token/`);
};
// End Admin

// Start Backup
export const getBackUpsService = () => {
  return http.get(`${base_url}/api/admin/v2/backups/`);
};
export const getBackUpService = (id) => {
  return http.get(`${base_url}/api/admin/v2/backups/${encodeURIComponent(id)}/`, { responseType: "blob" });
};

export const streamBackUpService = (id) => {
  return fetch(`${base_url}/api/admin/v2/backups/${encodeURIComponent(id)}/`, {
    headers: { Authorization: `token ${getCookies("accessToken") || ""}` },
    cache: "no-store",
  });
};

export const getAdminReportService = (data) => {
  return http.post(`${base_url}/api/admin/v2/backups/reports/`, data, { responseType: "blob" });
};
// End Backup

export const compareOrderAdminService = (data) => {
  return http.post(`${base_url}/api/admin/v2/orders/compare/`, data);
}

//Start Tara
export const refundTara = (data) => {
  return http.post(`${base_url}/api/admin/v2/tara/refund/${data.invoice.pk}/`, data);
};
//End Tara
